import { render, staticRenderFns } from "./comTerm6.vue?vue&type=template&id=131d4e45&scoped=true&"
import script from "./comTerm6.vue?vue&type=script&lang=js&"
export * from "./comTerm6.vue?vue&type=script&lang=js&"
import style0 from "./comTerm6.vue?vue&type=style&index=0&id=131d4e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d4e45",
  null
  
)

export default component.exports